import { useLocalStorageKeys } from "@dealer-center/core-interfaces-components";
import type { AtExperimentIdType } from "@dealer-center/core-pages-experiment-enablement-interface";
import { AtExperimentList } from "@dealer-center/core-pages-experiment-enablement-interface";
import { useExperimentPreferences } from "./useExperimentPreferences";

export const useAtExperimentPreferences =
  useExperimentPreferences<AtExperimentIdType>(
    AtExperimentList,
    useLocalStorageKeys.atExperimentEnablement
  );
